import { SocietyEmailSignature } from 'types/Society';

import defaultSignature from '../constants/defaultSignature';

type GenerateEmailSignatureProps = {
  signature: SocietyEmailSignature;
  linkColor: string;
};

const generateEmailSignature = ({
  signature,
  linkColor,
}: GenerateEmailSignatureProps) => {
  const name = signature.name || defaultSignature.name;
  const jobTitle = signature.jobTitle || defaultSignature.jobTitle;
  const logo = signature.logo || defaultSignature.logo;
  const website = signature.website || defaultSignature.website;
  const phone = signature.phone || defaultSignature.phone;
  const address = signature.address || defaultSignature.address;
  const footer = signature.footer || defaultSignature.footer;

  return `<div style="font-family: Arial, sans-serif; font-size: 14px;">
      <p style="line-height: 24px;">
        <b>${name}</b>
        <br />
        ${jobTitle}
      </p>
      <img src="${logo}" alt="signature logo" style="max-width: 100px; margin-bottom: 24px;" />
      <br />
      <p style="line-height: 18px; margin-bottom: 2px;">
        <a href="https://${website}" target="_blank" rel="noreferrer" style="color: ${linkColor};">
          ${website}
        </a>
        ${
          phone
            ? `<a href="tel:${phone}" style="color: ${linkColor};"> | Phone: ${phone}</a>`
            : ''
        }
      </p>
      <p style="line-height: 18px; margin-top: 2px;">
        <a href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          address
        )}" target="_blank" rel="noreferrer" style="color: ${linkColor};">
          ${address}
        </a>
      </p>
      <p style="color: grey; font-size: 10px;">${footer}</p>
    </div>`;
};

export default generateEmailSignature;
